<template>
  <div class="echarts" id="populationRightTwo"></div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
//
import { unitlist } from "@/api/threeSolid/threeSolidHome.js";
import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await prisonlist();
      data.echartsList = res.data;
    };
    onMounted(() => {
      // echarts项目初始化
      const myChart = echarts.init(
        document.getElementById("populationRightTwo")
      );
      myChart.setOption({
        grid: {
          top: 11,
          left: 5,
          right: 5,
          bottom: 5,
          containLabel: true,
        },
        title: {
          // text: "年龄结构",
        },
        textStyle: {
          // 图列内容样式
          color: "#b5bbc7", // 字体颜色
        },
        tooltip: {},
        xAxis: {
          data: ["少年", "儿童", "青年", "中年", "壮年", "老年"],
          axisLine: {
            lineStyle: {
              color: "#08598f", //横坐标线条颜色
            },
          },
        },
        yAxis: {
          height: 50,
          splitLine: {
            //网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
        },
        series: [
          {
            itemStyle: {
              color: "#326e9a",
              borderColor: "#5ea9d0",
            },
            barWidth: "20%",
            barWidth: "30%",
            name: "销量",
            type: "bar",
            data: [200, 400, 600, 800, 1000, 1200],
          },
        ],
      });
    });
  },
});
</script>
<style  lang='scss' scoped >
#populationRightTwo {
  width: 100%;
  height: 180px;
}
</style>